var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showContent)?_c('router-view'):_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("连接中，请稍等……")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }